module.exports = __webpack_public_path__ + "static/AngelaHe7-bf2c99f0e88e9d4df181218026b38458.png";